import React, { useEffect } from "react";
import CarrouselNews from "../components/Tensoblog/CarrouselNews";
import TagSocial from "../components/Tensoblog/TagSocial";
import CardBlog from "../components/Tensoblog/CardBlog";
import useNews from "../hooks/useNews";
import { useState } from "react";
import SearchIcon from "@mui/icons-material/Search";
import { lightBlue } from "@mui/material/colors";
import imgTag from "../assets/images/TensoBlog/TagNews.svg";
import imgBannerMobile from "../assets/images/TensoBlog/baner-mobile.png";
import imgBannerTablet from "../assets/images/TensoBlog/baner-tablet.png";
import imgBannerDisensa from "../assets/images/TensoBlog/banner-disensa-tablet.png";

function TensoNews() {
  const { news } = useNews();

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setTimeout(() => {
      setLoading(true);
    }, 2000);
  }, []);

  const [width, setWidth] = useState(1024);
  useEffect(() => {
    const updateWidth = () => {
      setWidth(window.innerWidth);
    };

    window.addEventListener("resize", updateWidth);

    if (window.innerWidth <= 860) setWidth(window.innerWidth);

    return () => {
      window.removeEventListener("resize", updateWidth);
    };
  }, []);

  return (
    <div className="container-main-tensoBlog">
      <div className="container-main-grid">
        <img className="tag-tensoBlog" src={imgTag} alt="Tenso News" />
        <div className="container-main-carrousel">
          <CarrouselNews loading={loading} />
          <TagSocial />
        </div>
        <div className="container-main-advertising">
          <div className="input-search">
            <input type="search" />
            <SearchIcon sx={{ color: lightBlue[500] }} />
          </div>
          <div className="container-main-cotizador">
          <a href="http://aceros.tensolite.com" target="_blank" rel="noopener noreferrer" className="me-md-2">
            <img
              className="container-main-cotizador--img-banner"
              src={width < 991 ? imgBannerMobile : imgBannerTablet}
              alt=""
            />
            </a>
          {
            width >= 576 ? (
                <img
                  className="container-main-cotizador--img-banner"
                  src={imgBannerDisensa}
                  alt=""
                />
            ) : null
          }
          </div>
        </div>
      </div>
      <div className="last-news">
        <h2>ÚLTIMAS NOTICIAS!</h2>
      </div>

      <div className="container-main-news">
        {news?.map(
          (noticia, index) =>
            noticia?.deleted === false &&
            noticia?.visible === true &&
            noticia?.publish === true && (
              <CardBlog
                key={index}
                noticia={noticia}
                tensoblog={true}
                loading={loading}
                tensoblogClass={true}
              />
            )
        )}
      </div>
    </div>
  );
}

export default TensoNews;
